import { useDispatch, useSelector } from 'react-redux'
import Parse from 'parse'

import {
  logout,
  selectUser,
  loginSuccess,
  MyReduxUser,
} from '../../store/slice/user'
import makeReduxUserFromParseUser from '../../utils/makeMyUserFromParseUser'

//parse user 가 변했을시 redux 도 따라 변하게 함
export const useUserReduxParse = () => {
  const reduxUser = useSelector(selectUser)
  const dispatch = useDispatch()
  const curUser = Parse.User.current()
  //현재 로그아웃되었지만 redux 는 새로고침 되지 않았을때
  if (curUser === undefined && reduxUser) {
    dispatch(logout())
    return curUser
  }
  // 파스로 로그인 됬지만 reduxuser 는 null 일때
  else if (curUser && reduxUser === null) {
    const newUser = makeReduxUserFromParseUser(curUser)
    dispatch(loginSuccess(newUser))
    return newUser
  }
  return reduxUser
}
